export default "__VITE_ASSET__DY5LpUdC__"